<div class="heading">
  <p class="f-body-l f-medium">{{ `${I18N}.borderCrossing` | translate }}</p>

  <onyx-flags [flags]="[border().from, border().to]" [size]="16"></onyx-flags>
</div>

<div class="content">
  <onyx-icon class="f-muted" name="location-filled" [size]="16"></onyx-icon>

  <div class="address-container">
    @if (border().address; as address) {
      <div class="address f-body-m f-medium">
        <span>
          @if (address.street) {
            {{ address.street }} {{ address.houseNumber }},
          }

          {{ address.zipCode }} {{ address.city }}
        </span>

        <onyx-flag [countryCode]="address.countryCode"></onyx-flag>
      </div>
    }

    <span class="coordinates f-muted">
      @let coordinates = border().coordinates;
      {{ coordinates.latitude }}, {{ coordinates.longitude }}
    </span>

    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="24"
      icon="copy-outlined"
      [circle]="true"
      [active]="true"
      (click)="copyCoordinates()"
    ></onyx-icon-button>
  </div>
</div>
